import get from "lodash/get";
import { connect } from "react-redux";
import compOperations from "../comp/ducks/operations";
import listingOperations from "../listing/ducks/operations";
import searchOperations from "../search/ducks/operations";
import voucherOperations from "../voucher/ducks/operations";
import PropertyUpdateModal from "./PropertyUpdateModal";
import operations from "./ducks/operations";

const PropertyUpdateModalContainer = (props) => {
    return <PropertyUpdateModal {...props} autocompleteResults={props.autocompleteResults} />;
};

const mapStateToProps = (state) => {
    return {
        isLoading: state.utilsReducer.isLoading,
        searchResults: state.searchReducer.autocompleteResults,
        autocompleteResults: state.searchReducer.autocompleteResults,
        displayUpdateDialog: state.propertyReducer.displayUpdateDialog,
        propertySearchModalStatus: state.propertyReducer.propertySearchModal,
        listingPropertyModal: state.listingReducer.requestModal,
        listing: get(state.listingReducer, "listing", {}),
        dealKey: get(state.dealReducer, "deal.dealKey", {}),
        user: get(state.authReducer, "userProfile.user", {}),
        errors: state.utilsReducer.errors,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchFunction: (term) => {
            dispatch(searchOperations.searchPropertyAutocomplete(term));
        },
        togglePropertySearchModal: (isOpen) => {
            dispatch(operations.togglePropertySearchModal(isOpen));
        },
        selectProperty: (property) => {
            dispatch(listingOperations.selectPropertyFromAutocomplete(property));
        },
        removeSelectedProperty: () => {
            dispatch(listingOperations.removeSelectedPropertyFromRequestModal());
        },
        updatePropertyForListing: (listingKey, propertyKey, user) => {
            return dispatch(listingOperations.updatePropertyForListing(listingKey, propertyKey, user));
        },
        updatePropertyForComp: (listingKey, propertyKey, user) => {
            return dispatch(compOperations.updatePropertyForComp(listingKey, propertyKey, user));
        },
        handleChooseDisplayUpdateDialog: (isOpen) => {
            dispatch(operations.toggleUpdateDialog(isOpen));
        },
        updatePropertyForConsulting: (dealKey, propertyKey, user) => {
            dispatch(voucherOperations.updatePropertyForConsulting(dealKey, propertyKey, user));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyUpdateModalContainer);
